var LineItemSellingPlanSelector = class extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector('select')
    this.key = this.dataset.key
    this.value = this.select.value
    this.enableCheckbox = this.querySelector('[data-enable-selling-plan]')
    this.selectWrapper = this.querySelector('[data-selling-plan-select]')
    this.checkboxWrapper = this.querySelector('[data-enable-selling-plan-wrap]')
    this.noPlanOption = this.querySelector('[data-none-value]')
    this.planOptions = this.querySelectorAll('[data-real-value]')

    this.getCart()
  }

  async getCart() {
    const cartJson = await (await fetch(`${Shopify.routes.root}cart.js`)).json()
    this.cartItems = cartJson.items
    this.init()
  }

  init() {
    this.cartItem = this.cartItems.find(item => item.key === this.key)
    this.selectWrapper.classList.toggle('hidden', !this.enableCheckbox.checked)
    this.checkboxWrapper.classList.toggle('hidden', this.enableCheckbox.checked)
    this.enableCheckbox.addEventListener('change', this.toggleSellingPlan.bind(this))
    this.select.addEventListener('change', this.changeSellingPlan.bind(this))
  }

  toggleSellingPlan () {
    this.selectWrapper.classList.toggle('hidden', !this.enableCheckbox.checked)
    this.checkboxWrapper.classList.toggle('hidden', this.enableCheckbox.checked)
    this.select.value = this.enableCheckbox.checked ? this.planOptions[0].value : this.noPlanOption.value
    const changeEvent = new Event('change')
    this.select.dispatchEvent(changeEvent)
  }

  async changeSellingPlan() {
    if (this.select.value === this.value) { return }
    const changeData = {
      id: this.cartItem.key,
      quantity: this.cartItem.quantity,
      selling_plan: (this.select.value === '0' ? null : Number(this.select.value))
    }

    await fetch(`${Shopify.routes.root}cart/change.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(changeData)
    })

    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }))

    if (window.themeVariables.settings.pageType !== "cart") { return }
    window.location.reload()
  }
};

if (!window.customElements.get('line-item-selling-plan-selector')) {
  window.customElements.define('line-item-selling-plan-selector', LineItemSellingPlanSelector);
}